import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Si Kuunda renvoie sur `/` (Site URL) avec ?token=, ?token_hash= ou #access_token,
 * on bascule vers /auth/callback pour finaliser la session.
 */
export function OAuthReturnFix() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/auth/callback') return;

    const params = new URLSearchParams(location.search);
    const hasCode = params.has('code');
    const hasTokenHash = params.has('token_hash') || params.has('token');
    const hash = location.hash || '';
    const hasToken =
      hash.includes('access_token') || hash.includes('refresh_token') || hash.includes('error=');

    if (hasCode || hasTokenHash || hasToken) {
      navigate(`/auth/callback${location.search}${location.hash}`, { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
}
